import styled from "styled-components";

export const Container = styled.div`
  width: 100%;

  .text-md {
    font-size: 1.3rem;
  }

  .message-success {
    max-width: 450px;
    margin: 0 auto;
    text-align: center;
  }

  .schedule-sec {
    margin-top: 60px;
  }

  .scheduleinfo {
    font-size: 1rem;
  }
`;

export const ContainerForm = styled.form`
  display: flex;
  flex-direction: column;

  .search-bar {
    display: flex;
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
    margin-top: 100px;
    position: relative;

    .field-holder {
      flex: 1;

      input {
        border-radius: 8px 0 0 8px;
      }
    }

    button {
      height: auto;
      position: relative;
      border-radius: 0 30px 30px 0;
      font-size: 1rem;
    }
  }

  ,
  .wrapper-loading {
    margin-top: 20px;
  }

  .wrap-text {
    width: 100%;
    max-width: 450px;
    margin: 20px auto 0;
  }
`;
